import React from 'react';
import { Query } from 'react-apollo';
import CategorySubcategories from '../CategorySubcategories.gql';
import NavigationItems from '../NavigationItems';
import { Above } from '@jetshop/ui/Breakpoints';
import ReadMore from '../../../Theme/ReadMore';

const SiblingCategories = ({ category }) => {
  const categoryId = category?.id;

  const subcategories = category?.subcategories;
  const hasSubcategories = subcategories?.length > 0;

  const parentCategoryId = category?.parent?.parent?.id
    ? category.parent.id
    : category?.parent?.id
    ? category.parent.id
    : null;

  return categoryId && parentCategoryId ? (
    <div>
      <Query query={CategorySubcategories} variables={{ id: parentCategoryId }}>
        {({ data, loading, error }) => {
          if (loading || error) return null;

          if (loading) return null;

          const subcategories = data?.category?.subcategories;

          return !subcategories?.length > 0 ? null : (
            <Above breakpoint="md">
              {matches =>
                matches ? (
                  <NavigationItems
                    categories={subcategories}
                    categoryId={categoryId}
                  />
                ) : (
                  <>
                    {!hasSubcategories ? (
                      <ReadMore condition={subcategories?.length > 6}>
                        <NavigationItems
                          categories={subcategories}
                          categoryId={categoryId}
                        />
                      </ReadMore>
                    ) : (
                      <NavigationItems
                        categories={subcategories}
                        categoryId={categoryId}
                      />
                    )}
                  </>
                )
              }
            </Above>
          );
        }}
      </Query>
    </div>
  ) : null;
};

export default SiblingCategories;
